import React from 'react';
import {DataItem} from 'src/design-system';
import * as Yup from 'yup';
import {Text} from 'react-native';
import {Typography} from 'src/styles';
import {IDeveloperField} from 'dromo-uploader-react';
import FormInput from 'src/hook-form-wrapper/form-input';

interface DisplayProps {
  value: string;
}

interface Props {
  name?: string;
}

export const Import = (
  key: string = 'name',
  prefix?: string,
): IDeveloperField => ({
  label: (prefix ? prefix + ' ' : '') + 'Plan Name',
  key,
  validators: [
    {
      validate: 'required',
    },
  ],
});

export const Value = (value: string) => {
  return value;
};

export const Display = ({value}: DisplayProps) => {
  return (
    <DataItem>
      <Text style={[Typography.H6]}>Plan Name</Text>
      <Text style={[Typography.P3]}>{Value(value) || '(No Plan Name)'}</Text>
    </DataItem>
  );
};

export const Input = ({name}: Props) => {
  return (
    <FormInput
      name={(name ? name + '.' : '') + 'name'}
      label={'Plan Name'}
      placeholder={'Plan Name'}
      helper={''}
      required={false}
    />
  );
};

export const validation = () => Yup.string().required('Plan name is required');

export default Input;
